<template>
  <svg
    width="20"
    height="20"
    class="search-svg"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.54506 17.6718L7.41442 12.8025C6.6588 11.8256 6.25005 10.6312 6.25005 9.37498C6.25005 7.87123 6.83692 6.46124 7.89817 5.39812C8.95941 4.335 10.3732 3.75 11.875 3.75C13.3769 3.75 14.7906 4.33687 15.8519 5.39812C16.915 6.45936 17.5 7.87123 17.5 9.37498C17.5 10.8768 16.9131 12.2906 15.8519 13.3518C14.7906 14.415 13.3788 15 11.875 15C10.6188 15 9.42628 14.5912 8.44941 13.8375L3.58006 18.7049C3.56578 18.7192 3.54883 18.7306 3.53017 18.7383C3.51151 18.746 3.49151 18.75 3.47131 18.75C3.45111 18.75 3.43111 18.746 3.41245 18.7383C3.39379 18.7306 3.37684 18.7192 3.36256 18.7049L2.54506 17.8893C2.53078 17.875 2.51945 17.8581 2.51171 17.8394C2.50398 17.8208 2.5 17.8008 2.5 17.7806C2.5 17.7604 2.50398 17.7404 2.51171 17.7217C2.51945 17.703 2.53078 17.6861 2.54506 17.6718ZM8.90504 12.345C9.70003 13.1381 10.7538 13.575 11.875 13.575C12.9963 13.575 14.05 13.1381 14.845 12.345C15.6381 11.55 16.075 10.4962 16.075 9.37498C16.075 8.25373 15.6381 7.19811 14.845 6.40499C14.05 5.61187 12.9963 5.17499 11.875 5.17499C10.7538 5.17499 9.69816 5.60999 8.90504 6.40499C8.11192 7.19999 7.67504 8.25373 7.67504 9.37498C7.67504 10.4962 8.11192 11.5518 8.90504 12.345Z"
    />
  </svg>
</template>
<script>
export default {
  name: 'SearchSvg'
}
</script>
<style lang="sass">
.search-svg
  fill: currentColor
</style>
